import { jsx as _jsx } from "react/jsx-runtime";
import { Icon } from '@iconify/react';
import closeCircleFill from '@iconify/icons-eva/close-circle-fill';
export default function Chip(theme) {
    return {
        MuiChip: {
            defaultProps: {
                deleteIcon: _jsx(Icon, { icon: closeCircleFill }, void 0),
            },
            styleOverrides: {
                label: {
                    marginTop: -4,
                },
                colorDefault: {
                    '& .MuiChip-avatarMedium, .MuiChip-avatarSmall': {
                        color: theme.palette.text.secondary,
                    },
                },
                outlined: {
                    borderColor: theme.palette.grey[50032],
                    '&.MuiChip-colorPrimary': {
                        borderColor: theme.palette.primary.main,
                    },
                    '& .MuiSvgIcon-root': {
                        color: 'inherit',
                    },
                },
            },
        },
    };
}
//# sourceMappingURL=Chip.js.map